import { red } from '@material-ui/core/colors';
import { createMuiTheme } from '@material-ui/core/styles';

// A custom theme for this app
const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#263238',
    },
    secondary: {
      main: '#607d8b',
    },
    error: {
      main: red.A400,
    },
    background: {
      default: '#eceff1',
    },
  },
});

export default theme;
